'use strict';

const Reflux = require('@muzzylane/reflux');
const reject = require('lodash/reject');

const GlobalFeaturedDemoActions = require('../actions/GlobalFeaturedDemoActions');
const SignInActions = require('../actions/sign_in_actions');

let featuredDemos = [];
let action = {};

const GlobalFeaturedDemoStore = Reflux.createStore({
    listenables: [GlobalFeaturedDemoActions, SignInActions],

    init: function() { return; },

    resetState: function() {
        featuredDemos = [];
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            featuredDemos: featuredDemos,
            action: action
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onGetAllCompleted: function(actionId, res) {
        console.log('onGetAllCompleted:', actionId, res);
        action = { id: actionId };
        featuredDemos = res;
        this.emitStatus();
    },

    onGetAllFailed: function(actionId, err) {
        console.warn("onGetAllFailed:", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddCompleted: function(actionId, res) {
        action = { id: actionId };
        featuredDemos.push(res);
        this.emitStatus();
    },

    onAddFailed: function(actionId, err) {
        console.warn("onAddFailed:", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateCompleted: function(actionId, demoId, res) {
        action = { id: actionId };
        featuredDemos = featuredDemos.map((demo) => {
            if (demo.fd_id === demoId) {
                return res;
            }
            return demo;
        });
        this.emitStatus();
    },

    onUpdateFailed: function(actionId, demoId, err) {
        console.warn("onUpdateFailed:", actionId, demoId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteCompleted: function(actionId, demoId) {
        action = { id: actionId };
        featuredDemos = reject(featuredDemos, { fd_id: demoId });
        this.emitStatus();
    },

    onDeleteFailed: function(actionId, demoId, err) {
        console.warn("onDeleteFailed:", actionId, demoId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    }
});

module.exports = GlobalFeaturedDemoStore;